export default __webpack_public_path__ + "static/char-s-13-chs-edc11801d76778165bd07c5437ba87d9.png";